import styled from 'styled-components';
import device from 'utils/device';

export const ContentWrapper = styled.div`
  background-color: white;
  border-radius: 30px;
  width: calc(100vw - 10px);
  height: calc(100% - 10px);
  position: relative;

  @media ${device.laptop} {
    background-color: unset;
    background-color: ${p => p.background};
    box-shadow: 0px 4px 40px rgba(160, 174, 192, 0.15);
    max-height: calc(100vh - 70px);
    max-width: calc(100vw - 100px);
    width: ${p => p.width ? p.width : '800px'};
    height: ${p => p.height ? p.height : 'unset'};
  }
`;
